import { makeStyles, Text, tokens } from '@fluentui/react-components';
import type { ReactNode } from 'react';

import { spacing } from '@/theme/tokens';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.l,
    paddingBottom: spacing.xxl,
    marginBottom: spacing.xxl,
    borderBottomColor: tokens.colorNeutralStroke3,
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
  },
  description: {
    color: tokens.colorNeutralForeground3,
    maxWidth: '720px',
  },
  trailing: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.s,
  },
});

interface PageHeaderProps {
  title: string;
  description?: string;
  trailing?: ReactNode;
}

export function PageHeader({ title, description, trailing }: PageHeaderProps) {
  const classes = useStyles();
  return (
    <header className={classes.root}>
      <div className={classes.text}>
        <Text size={700} weight="semibold">
          {title}
        </Text>
        {description ? (
          <Text size={300} className={classes.description}>
            {description}
          </Text>
        ) : null}
      </div>
      {trailing ? <div className={classes.trailing}>{trailing}</div> : null}
    </header>
  );
}
